import { getOrgFiltersMap } from "../../helpers/filters"
import { ContentType, WidgetDataParams, WidgetName } from "../../types"

export const INSIGHTS_WIDGETS_REQUEST_PARAMS: Partial<
  Record<WidgetName, WidgetDataParams>
> = {
  AverageTestsCompleted: {
    type: "atc",
    entity: "students-usage",
    allowedFilters: [
      "state",
      "district",
      "school",
      "teacher",
      "class",
      "student",
      "grade",
      "usageContentType",
      "test"
    ],
    requests: [
      {
        measures: ["usage_students.averageSubmittedTests"]
      }
    ],
    fields: {
      submittedTests: "usage_students.averageSubmittedTests",
      date: "usage_students.createdAt"
    }
  },
  AverageQuestionsAnswered: {
    type: "aqa",
    entity: "students-usage",
    allowedFilters: [
      "state",
      "district",
      "school",
      "teacher",
      "class",
      "student",
      "grade",
      "usageContentType",
      "test"
    ],
    requests: [
      {
        measures: ["usage_average_questions_answered.averageQuestionsAnswered"],
        timeDimensions: [
          {
            dimension: "usage_average_questions_answered.createdAt",
            dateRange: ""
          }
        ]
      }
    ],
    fields: {
      questionsAnswered:
        "usage_average_questions_answered.averageQuestionsAnswered",
      date: "usage_average_questions_answered.createdAt"
    }
  },
  // TODO: update widget settings
  AverageParticipants: {
    type: "ap",
    entity: "teachers-usage",
    allowedFilters: [],
    requests: [
      {
        measures: []
      }
    ],
    fields: {
      participants: "",
      date: ""
    }
  },
  PerformancePracticeTestsAverageScore: {
    type: "contentAverageScore",
    label: "Average Score",
    entity: "content-library",
    contentType: ContentType.practiceTest
  }
}

export const INSIGHTS_WIDGETS_BY_VIEW: Record<string, WidgetName[]> = {
  "students-usage": [],
  "teachers-usage": ["AverageDaysActive"],
  questions: [
    // "PerformancePracticeTestsAverageScore"
  ],
  studentQuestions: [
    // "PerformancePracticeTestsAverageScore"
  ],
  scores: [
    // "PerformancePracticeTestsAverageScore"
  ],
  "subtests-scores": [
    // "PerformancePracticeTestsAverageScore"
  ],
  answers: ["PerformancePracticeTestsAverageScore"]
}

export const INSIGHTS_WIDGETS_FILTER_MAP: Partial<
  Record<WidgetName, Record<string, string>>
> = {
  AverageTestsCompleted: {
    ...getOrgFiltersMap("usage_students"),
    "tests.program": "usage_students.program",
    "tests.subject": "usage_students.subject",
    "content.type": "usage_students.contentType"
  },
  AverageQuestionsAnswered: {
    ...getOrgFiltersMap("usage_average_questions_answered"),
    "tests.program": "usage_average_questions_answered.program",
    "tests.subject": "usage_average_questions_answered.subject",
    "content.type": "usage_average_questions_answered.contentType"
  },
  // TODO:
  AverageParticipants: {}
}
